import { CalendarDays } from 'lucide-react';
import { hojeNoFuso } from '../../componentes/periodo/periodo';
import { data, dataHora, nomeCadastro, nomeParceiro, textoLivre } from '../../nucleo/formato';
import { caminhoDaAba, type FonteBuscaGlobal } from '../../nucleo/modulos-web';

/**
 * Lista de 30/10 (item 10): agendamentos e reuniões na busca da barra superior (a busca da Agenda casa cliente, assunto,
 * serviço e profissional). Abre a semana do agendamento com o drawer dele (`?data=` e `?agendamento=`).
 */
interface AgendamentoBusca {
  id: string;
  inicio: string;
  dia_inteiro?: boolean;
  assunto?: string | null;
  /** Nulos na reunião livre (03/11): nesse caso não há o que mostrar (nome nulo com id é cadastro de outra empresa). */
  servico_id?: string | null;
  servico_nome: string | null;
  recurso_nome: string | null;
  parceiro_id?: string | null;
  parceiro_nome: string | null;
}

/** Dia local (AAAA-MM-DD) do início, como a semana da Agenda lê. */
const diaLocal = (iso: string) => {
  const d = new Date(iso);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

export const buscaAgenda: FonteBuscaGlobal[] = [
  {
    chave: 'agendamentos',
    permissao: 'agenda.ver',
    pagina: 'agenda.semana',
    grupo: 'buscaGlobal.agendamentos',
    posicao: 50,
    icone: CalendarDays,
    item: (a: AgendamentoBusca, _t, fuso) => {
      // Rodada rrl-11 (ROB11-B2): dia inteiro é uma data do workspace, sem as 00:00, e abre a semana desse dia.
      const dia = a.dia_inteiro && fuso ? hojeNoFuso(fuso, new Date(a.inicio)) : null;
      return {
        id: a.id,
        rotulo: a.assunto ? textoLivre(a.assunto, a.parceiro_nome) : nomeParceiro(a.parceiro_nome),
        detalhe: [dia ? data(dia) : dataHora(a.inicio), a.assunto ? (a.parceiro_id === null ? null : nomeParceiro(a.parceiro_nome)) : a.servico_id === null ? null : nomeCadastro(a.servico_nome), nomeCadastro(a.recurso_nome)].filter(Boolean).join(' · '),
        link: `${caminhoDaAba('agenda', 'semana')}?data=${dia ?? diaLocal(a.inicio)}&agendamento=${a.id}`,
      };
    },
  },
];
